import { BudgetCategory } from "../types";
import {
  getBudgetCategoryEstimate,
  getBudgetEstimateContingency,
  getBudgetTotalEstimate,
} from "../BudgetItemUtils";

export interface BudgetBreakdownSegment {
  id: string;
  name: string;
  estimate: number;
  sharePercent: number;
  // Index into the category palette; negative for the contingency band.
  colorIndex: number;
  isContingency: boolean;
}

export interface BudgetBreakdown {
  segments: BudgetBreakdownSegment[];
  grandTotal: number;
}

export const buildBudgetBreakdown = (
  categories: BudgetCategory[],
  contingencyPercentage: number
): BudgetBreakdown => {
  const categoryEstimates = categories.map((category) => ({
    category,
    estimate: getBudgetCategoryEstimate(category, categories),
  }));

  const contingency = {
    contingency_percentage: contingencyPercentage,
    locked: false,
    actual_amount: null,
  };
  const contingencyEstimate = getBudgetEstimateContingency(categories, contingency);
  const grandTotal = getBudgetTotalEstimate(categories, contingency);

  const toShare = (estimate: number) => (grandTotal > 0 ? (estimate / grandTotal) * 100 : 0);

  const segments: BudgetBreakdownSegment[] = categoryEstimates.map((entry, index) => ({
    id: `category-${entry.category.budget_category_id}`,
    name: entry.category.name,
    estimate: entry.estimate,
    sharePercent: toShare(entry.estimate),
    colorIndex: index,
    isContingency: false,
  }));

  if (contingencyEstimate > 0) {
    segments.push({
      id: "contingency",
      name: "Contingency",
      estimate: contingencyEstimate,
      sharePercent: toShare(contingencyEstimate),
      colorIndex: -1,
      isContingency: true,
    });
  }

  return { segments, grandTotal };
};
